/**
 * Textos de número e data compartilhados entre o app e as mensagens do bot, para que o alerta do
 * Telegram e a tela digam exatamente a mesma coisa.
 */

const MONTHS = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];

/** "3.620" — reais sem centavos, separador de milhar pt-BR (igual ao formatBRL do design system). */
export function brl(value: number): string {
  return Math.round(value)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

/** "R$ 3.620" */
export function money(value: number): string {
  return `R$ ${brl(value)}`;
}

function parts(day: string) {
  const [y, m, d] = day.split('-').map(Number) as [number, number, number];
  return { y, m, d };
}

/** "21 mai 2027" */
export function formatDay(day: string): string {
  const { y, m, d } = parts(day);
  return `${d} ${MONTHS[m - 1]} ${y}`;
}

/** "21 mai" */
export function formatDayShort(day: string): string {
  const { m, d } = parts(day);
  return `${d} ${MONTHS[m - 1]}`;
}

/**
 * Datas da rota no formato do design system:
 * "21–28 mai 2027 · ida e volta", "30 mai – 6 jun 2027 · ida e volta", "21 mai 2027 · só ida".
 */
export function formatRouteDates(outbound: string, ret: string | null, withKind = true): string {
  if (!ret) return `${formatDay(outbound)}${withKind ? ' · só ida' : ''}`;
  const a = parts(outbound);
  const b = parts(ret);
  let range: string;
  if (a.y !== b.y) range = `${formatDay(outbound)} – ${formatDay(ret)}`;
  else if (a.m !== b.m) range = `${formatDayShort(outbound)} – ${formatDayShort(ret)} ${b.y}`;
  else range = `${a.d}–${b.d} ${MONTHS[b.m - 1]} ${b.y}`;
  return `${range}${withKind ? ' · ida e volta' : ''}`;
}

/** "1 adulto", "2 adultos" */
export function formatAdults(n: number): string {
  return n === 1 ? '1 adulto' : `${n} adultos`;
}

/** Primeiro nome para o chamado do alerta: "Viaja, Cris!" */
export function firstName(name: string): string {
  return name.trim().split(/\s+/)[0] || name;
}
